import { HeroSearchForm } from "components/HeroSearchForm/HeroSearchForm";
import { HeroSearchFormMobile } from "components/HeroSearchForm/HeroSearchFormMobile";
import { FC } from "react";
import imagePng from "images/hero-right.png";

export interface SectionHero4Props {
  className?: string;
}

const SectionHero4: FC<SectionHero4Props> = ({ className = "" }) => {
  return (
    <div
      className={`nc-SectionHero3 mb-80 md:mb-52 bg-black bg-opacity-70 lg:mb-0 relative ${className}`}
      data-nc-id="SectionHero3"
    >
      <div
        className="absolute inset-x-0 top-[20%]  md:top-[20%] lg:top-[15%] text-left flex flex-col items-start  mx-auto space-y-3 lg:space-y-3 xl:space-y-5 ml-0 lg:ml-12"
        style={{ zIndex: 1 }}
      >
        <div className="hidden lg:flex flex-col items-start">
          <h2 className="max-w-3xl px-4 sm:px-0 font-black text-6xl xl:text-7xl !leading-[114%] text-white mb-16 md:mb-4">
            Apex Luxe Rentals –{" "}
            <span
              className="bg-gradient-to-r from-[#d4af37] to-[#ffd700] bg-clip-text text-transparent font-bold"
            >
              Drive in Style{" "}
            </span>
            with Exceptional Service
          </h2>

          <span className="max-w-3xl text-lg  text-[#FFFFFFCC] flex">
            At Apex Luxe Rentals, we believe in offering an unparalleled driving
            experience that combines luxury, sustainability, and economy.
          </span>
        </div>
        <div className="hidden lg:flex items-start justify-center p-12 w-full">
          <HeroSearchForm />
        </div>
        <div className="lg:hidden px-4 w-full">
          <HeroSearchFormMobile />
        </div>
      </div>

      <div className="relative  aspect-w-1 aspect-h-1 sm:aspect-w-4 sm:aspect-h-3 lg:aspect-w-16 lg:aspect-h-9 xl:aspect-h-8 ">
        <img
          className="absolute inset-0 object-cover w-full opacity-70"
          src={imagePng}
          alt="hero"
        />
      </div>
    </div>
  );
};

export default SectionHero4;
